
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.595 12.255a.545.545 0 00.247-.327L10.12.676a.567.567 0 00-.03-.41.459.459 0 00-.295-.244.47.47 0 00-.387.047c-.12.071-.201.18-.245.327L5.88 11.648c-.04.15-.03.287.03.41a.46.46 0 00.3.244c.135.04.264.025.385-.047zm4.702-1.792c.139.001.265-.05.38-.157l4.135-3.734a.556.556 0 00.167-.264.535.535 0 00-.167-.556l-4.136-3.734a.543.543 0 00-.38-.16.448.448 0 00-.351.166.455.455 0 00-.13.365.552.552 0 00.185.36l3.772 3.41L11 9.574a.55.55 0 00-.185.358.467.467 0 00.13.368c.095.107.212.16.352.163zm-6.592.002a.461.461 0 00.355-.165.463.463 0 00.124-.365A.532.532 0 005 9.58L1.227 6.165 5 2.75a.55.55 0 00.184-.358.476.476 0 00-.124-.368.468.468 0 00-.355-.16.55.55 0 00-.376.154L.188 5.752a.556.556 0 00-.168.264.528.528 0 00.003.297.56.56 0 00.165.259l4.14 3.74a.55.55 0 00.377.153z","fill":"#175F69"}})])
          )
        }
      }
    